import { AsyncButton } from "aic";
import { REDO, UNDO } from "contexts/appsettings/interface";
import { useAppSettings, useTlfContext } from "contexts/AppSettingsContext";
import { ReactNode } from "react";
import { ButtonGroup } from "react-bootstrap";
import { ArrowClockwise, ArrowCounterclockwise } from "react-bootstrap-icons";

/**
 * Undo/redo toolbar buttons for the TLF editor, using the unified editable-data
 * history while preserving TLF visibility and read-only permissions.
 *
 * @returns A set of toolbar buttons for undo and redo operations.
 */
export const TlfUndoButtons = (): ReactNode => {
  const tlfContext = useTlfContext();
  const { undoHistory, undoIndex, dispatch } = useAppSettings();
  return !tlfContext.tlfData || tlfContext.readOnly ? null : (
    <div style={{ position: "relative", width: "100%" }}>
      <ButtonGroup style={{ position: "absolute", top: "-16px", right: 0, zIndex: 2 }}>
        <AsyncButton
          id="tlf-undo-button"
          className="border border-dark"
          variant="warning"
          size="sm"
          aria-label="Undo"
          onClick={() => dispatch({ operation: UNDO, calledFrom: "TlfUndoButtons:Undo" })}
          disabled={undoIndex === 0}
        >
          <ArrowCounterclockwise />
        </AsyncButton>
        <AsyncButton
          id="tlf-redo-button"
          className="border border-dark"
          variant="warning"
          size="sm"
          aria-label="Redo"
          onClick={() => dispatch({ operation: REDO, calledFrom: "TlfUndoButtons:Redo" })}
          disabled={undoIndex >= undoHistory.length}
        >
          <ArrowClockwise />
        </AsyncButton>
      </ButtonGroup>
    </div>
  );
};

TlfUndoButtons.displayName = "TlfUndoButtons";
